import {gql,TypedDocumentNode} from '@apollo/client';
import {Stage} from "./getStages";

interface Result {
    id: string,
}

interface Variables {
    input: Stage
}

export const UPDATE_STAGE: TypedDocumentNode<Result, Variables> = gql`
    mutation UpdateStage($input: UpdateStageInput){
        updateStage(input: $input) {
            id
        }
    }   
`
